import React, { useEffect, useRef, useState } from 'react';

import { getHighlightedText, getLangCountryPrefix, resolveArguments } from 'helpers/utils';

import * as Sentry from '@sentry/react';

import { MobileHelpLink } from './styles';
import { HELP_PAYSEND } from '../../../constants/UrlConstants';
import { LightIcon } from '../common/fromAuth/LightIcon/LightIcon';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { PromoEmptyPage } from '../form/PromoInputPhoneWithDropdown/PromoEmptyPage';
import { PromoSearchBar } from '../form/PromoInputPhoneWithDropdown/PromoSearchBar';
import { getZendeskLocale, useDebounce } from '../utils';
import PromoModalComponent from '../utils/PromoModalComponent';

const searchArticles = async (lang, country, query) => {
    const href = `${HELP_PAYSEND}/api/v2/help_center/articles/search.json?query=${query}&locale=${getZendeskLocale(lang, country)}&per_page=10`;
    try {
        const resp = await fetch(href, { method: 'GET' });
        if (resp.status === 200) {
            const json = await resp.json();
            return json;
        }
    } catch (e) {
        Sentry.captureException(e, {
            level: 'log',
        });
        return null;
    }
};

const getArticles = async (lang, country, query, sections) => {
    const articles = await searchArticles(lang, country, query);

    if (articles) {
        return articles.results.map((article) => {
            const section = sections.find((s) => s.id === article.section_id);
            return {
                id: article.id,
                title: article.title,
                section_id: article.section_id,
                category_id: section.category_id,
            };
        });
    }

    return null;
};

export const ZendeskHelpMobileSearchModal = (props) => {
    const searchRef = useRef(null);

    const [search, setSearch] = useState('');
    const [foundArticles, setFoundArticles] = useState({
        articlesList: [],
        query: '',
    });

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;

    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        const fetchData = async (query) => {
            if (!query) {
                return;
            }

            const articles = await getArticles(props.lang, props.country, query, props.sections);

            if (articles) {
                setFoundArticles({
                    articlesList: articles,
                    query: query,
                });
            }
        };

        fetchData(debouncedSearch);
    }, [debouncedSearch]);

    const articlesNames = foundArticles?.articlesList?.map((article) => {
        return (
            <MobileHelpLink key={article.id} href={`${url}/category/${article.category_id}/section/${article.section_id}/article/${article.id}`}>
                {!!foundArticles?.query ? (
                    <span>{getHighlightedText(foundArticles?.query, article.title, 'lightText')}</span>
                ) : (
                    <LightText>{article.title}</LightText>
                )}
                <LightIcon name="chevron-right" color={'purple'} leftIndent={'16px'} />
            </MobileHelpLink>
        );
    });

    return (
        <PromoModalComponent canCloseModal={false}>
            {articlesNames?.length === 0 && search && (
                <PromoEmptyPage
                    showChat
                    chatButton={props.chatButton}
                    toggleChat={props.toggleChat}
                    notFoundMessage={resolveArguments(props.searchNoResult, search)}
                    buttonId={'helpPageChatButton'}
                />
            )}
            {articlesNames?.length > 0 && search && <div>{articlesNames}</div>}
            <LightNavBar isSearchBar>
                <PromoSearchBar
                    searchRef={searchRef}
                    placeholder={props.searchPlaceholder}
                    onChange={(e) => setSearch(e.target.value)}
                    onCloseButtonClick={props.toggleSearch}
                />
            </LightNavBar>
        </PromoModalComponent>
    );
};
